import React from "react";
import { Flex, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import Icon from "../../../assets/image4.svg";
import dayjs from "dayjs";

export interface TransactionData {
  depositDate: Date | string;
  paymentOption: string;
  idNumber: string;
  depositAmount: number | string;
}

interface TransactionsTabProps {
  transactions: TransactionData[];
}

const TransactionsTab: React.FC<TransactionsTabProps> = ({ transactions }) => {
  const columns: ColumnsType<TransactionData> = [
    {
      title: "Date",
      dataIndex: "depositDate",
      key: "depositDate",
      sorter: (a, b) =>
        new Date(a.depositDate).getTime() - new Date(b.depositDate).getTime(),
      defaultSortOrder: "descend",
      render: (value) =>
        typeof value === "string"
          ? dayjs(value).format("D MMM, YYYY")
          : String(value),
    },
    {
      title: "Payment Method",
      dataIndex: "paymentOption",
      key: "paymentOption",
      sorter: (a, b) => a.paymentOption.localeCompare(b.paymentOption),
      render: (value) => (
        <Flex align="center">
          <img src={Icon} alt="icon" />
          {value}
        </Flex>
      ),
    },
    {
      title: "ID Number",
      dataIndex: "idNumber",
      key: "idNumber",
      sorter: (a, b) => a.idNumber.localeCompare(b.idNumber),
    },
    {
      title: "Amount",
      dataIndex: "depositAmount",
      key: "depositAmount",
      align: "right",
      sorter: (a, b) => Number(a.depositAmount) - Number(b.depositAmount),
      render: (value) => Number(value).toFixed(2),
    },
  ];

  return (
    <div className="transactions-table">
      <Table<TransactionData>
        dataSource={transactions}
        columns={columns}
        rowKey="idNumber"
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} transactions`,
        }}
      />
    </div>
  );
};

export default TransactionsTab;
